export * from './gender-api.service';
export * from './gender-api.interface';
